<template>
    <div v-if="show" class="col-12 col-md-6 col-lg-4 d-flex flex-column">
        <my-latest-updates
            :hide-if-empty="true"
            :endpoint="endpoint"
            :link="link"
            :link-text="linkText"
        ></my-latest-updates>
    </div>
</template>

<script>
import MyLatestUpdates from '@/components/updates/my-latest-updates';

export default {
    components: {
        MyLatestUpdates
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        link: {
            type: String,
            default: ''
        },
        linkText: {
            type: String,
            default: ''
        },
        endpoint: {
            type: String,
            default: '/api/v1/domainapi/MyLatestUpdates'
        }
    },
    data() {
        return {
            show: true
        };
    },

    methods: {
        hideBlock() {
            this.show = false;
        },
        showBlock() {
            this.show = true;
        }
    }
};
</script>
